/**
 * @generated SignedSource<<8f767faab26fa2c3803f9d64eace352e>>
 * @relayHash 767409598881887aa79d216996b506d5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6841cfcc0970a95f1d151af08e5fdeee1588edf1ca9d6b1e88d51154f26c4932

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceBlogPostStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentType = "ATTACHMENT" | "BLOG_POST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ConfluencePageStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
export type SearchSortOrder = "ASC" | "DESC" | "%future added value";
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  participants?: SearchParticipants | null | undefined;
  range?: SearchCommonRangeFilter | null | undefined;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null | undefined;
  lastModified?: SearchCommonRangeFilterFields | null | undefined;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null | undefined;
  containerARIs?: ReadonlyArray<string> | null | undefined;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null | undefined> | null | undefined;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null | undefined;
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  creatorsFilter?: ReadonlyArray<string> | null | undefined;
  isVerified?: boolean | null | undefined;
  labelsFilter?: ReadonlyArray<string> | null | undefined;
  mentions?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
  pageStatus?: ReadonlyArray<string> | null | undefined;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null | undefined> | null | undefined;
  spacesFilter?: ReadonlyArray<string> | null | undefined;
  titleMatchOnly?: boolean | null | undefined;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchSortInput = {
  field: string;
  key?: string | null | undefined;
  order: SearchSortOrder;
};
export type SearchResultsAGGSearchQuery$variables = {
  after?: string | null | undefined;
  cloudIdARI: ReadonlyArray<string>;
  commonFilters?: SearchCommonFilter | null | undefined;
  confluenceFilters?: SearchConfluenceFilter | null | undefined;
  disableQueryReplacement?: boolean | null | undefined;
  entities: ReadonlyArray<string>;
  experience: string;
  includeRecommended?: boolean | null | undefined;
  isLicensed: boolean;
  limit: number;
  query: string;
  sort?: ReadonlyArray<SearchSortInput | null | undefined> | null | undefined;
  spaceId: string;
  tenantId: string;
};
export type SearchResultsAGGSearchQuery$data = {
  readonly search: {
    readonly results: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly confluenceEntity?: {
            readonly __typename: "ConfluenceBlogPost";
            readonly author: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly blogPostStatus: ConfluenceBlogPostStatus | null | undefined;
            readonly commentCountSummary: {
              readonly total: number | null | undefined;
            } | null | undefined;
            readonly editorVersion: ReadonlyArray<{
              readonly __typename: "ConfluenceBlogPostProperty";
              readonly key: string;
              readonly value: string;
            } | null | undefined> | null | undefined;
            readonly id: string;
            readonly likesSummary: {
              readonly count: number | null | undefined;
            } | null | undefined;
            readonly links: {
              readonly editUi: string | null | undefined;
              readonly webUi: string | null | undefined;
            } | null | undefined;
            readonly metadata: {
              readonly titleEmojiDraft: {
                readonly __typename: "ConfluenceContentTitleEmoji";
                readonly id: string | null | undefined;
                readonly key: string | null | undefined;
                readonly value: string | null | undefined;
              } | null | undefined;
              readonly titleEmojiPublished: {
                readonly __typename: "ConfluenceContentTitleEmoji";
                readonly id: string | null | undefined;
                readonly key: string | null | undefined;
                readonly value: string | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly owner: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly space: {
              readonly alias: string | null | undefined;
              readonly id: string;
              readonly key: string | null | undefined;
              readonly name: string | null | undefined;
            } | null | undefined;
            readonly title: string | null | undefined;
            readonly type: ConfluenceContentType | null | undefined;
            readonly viewer: {
              readonly favoritedSummary: {
                readonly isFavorite: boolean;
              } | null | undefined;
            } | null | undefined;
          } | {
            readonly __typename: "ConfluenceDatabase";
            readonly author: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly commentCountSummary: {
              readonly total: number | null | undefined;
            } | null | undefined;
            readonly contentStatus: ConfluenceContentStatus | null | undefined;
            readonly id: string;
            readonly links: {
              readonly webUi: string | null | undefined;
            } | null | undefined;
            readonly owner: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly space: {
              readonly alias: string | null | undefined;
              readonly id: string;
              readonly key: string | null | undefined;
              readonly name: string | null | undefined;
            } | null | undefined;
            readonly title: string | null | undefined;
            readonly type: ConfluenceContentType | null | undefined;
            readonly viewer: {
              readonly favoritedSummary: {
                readonly isFavorite: boolean;
              } | null | undefined;
            } | null | undefined;
          } | {
            readonly __typename: "ConfluenceEmbed";
            readonly author: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly commentCountSummary: {
              readonly total: number | null | undefined;
            } | null | undefined;
            readonly contentStatus: ConfluenceContentStatus | null | undefined;
            readonly id: string;
            readonly links: {
              readonly webUi: string | null | undefined;
            } | null | undefined;
            readonly metadata: {
              readonly titleEmojiDraft: {
                readonly __typename: "ConfluenceContentTitleEmoji";
                readonly id: string | null | undefined;
                readonly key: string | null | undefined;
                readonly value: string | null | undefined;
              } | null | undefined;
              readonly titleEmojiPublished: {
                readonly __typename: "ConfluenceContentTitleEmoji";
                readonly id: string | null | undefined;
                readonly key: string | null | undefined;
                readonly value: string | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly owner: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly space: {
              readonly alias: string | null | undefined;
              readonly id: string;
              readonly key: string | null | undefined;
              readonly name: string | null | undefined;
            } | null | undefined;
            readonly title: string | null | undefined;
            readonly type: ConfluenceContentType | null | undefined;
            readonly viewer: {
              readonly favoritedSummary: {
                readonly isFavorite: boolean;
              } | null | undefined;
            } | null | undefined;
          } | {
            readonly __typename: "ConfluenceFolder";
            readonly author: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly contentStatus: ConfluenceContentStatus | null | undefined;
            readonly id: string;
            readonly links: {
              readonly webUi: string | null | undefined;
            } | null | undefined;
            readonly owner: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly space: {
              readonly alias: string | null | undefined;
              readonly id: string;
              readonly key: string | null | undefined;
              readonly name: string | null | undefined;
            } | null | undefined;
            readonly title: string | null | undefined;
            readonly type: ConfluenceContentType | null | undefined;
            readonly viewer: {
              readonly favoritedSummary: {
                readonly isFavorite: boolean;
              } | null | undefined;
            } | null | undefined;
          } | {
            readonly __typename: "ConfluencePage";
            readonly author: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly commentCountSummary: {
              readonly total: number | null | undefined;
            } | null | undefined;
            readonly editorVersion: ReadonlyArray<{
              readonly __typename: "ConfluencePageProperty";
              readonly key: string;
              readonly value: string;
            } | null | undefined> | null | undefined;
            readonly id: string;
            readonly likesSummary: {
              readonly count: number | null | undefined;
            } | null | undefined;
            readonly links: {
              readonly editUi: string | null | undefined;
              readonly webUi: string | null | undefined;
            } | null | undefined;
            readonly metadata: {
              readonly titleEmojiDraft: {
                readonly __typename: "ConfluenceContentTitleEmoji";
                readonly id: string | null | undefined;
                readonly key: string | null | undefined;
                readonly value: string | null | undefined;
              } | null | undefined;
              readonly titleEmojiPublished: {
                readonly __typename: "ConfluenceContentTitleEmoji";
                readonly id: string | null | undefined;
                readonly key: string | null | undefined;
                readonly value: string | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly owner: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly pageStatus: ConfluencePageStatus | null | undefined;
            readonly space: {
              readonly alias: string | null | undefined;
              readonly id: string;
              readonly key: string | null | undefined;
              readonly name: string | null | undefined;
            } | null | undefined;
            readonly subtype: ConfluencePageSubType | null | undefined;
            readonly title: string | null | undefined;
            readonly type: ConfluenceContentType | null | undefined;
            readonly viewer: {
              readonly favoritedSummary: {
                readonly isFavorite: boolean;
              } | null | undefined;
            } | null | undefined;
          } | {
            readonly __typename: "ConfluenceWhiteboard";
            readonly author: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly commentCountSummary: {
              readonly total: number | null | undefined;
            } | null | undefined;
            readonly contentStatus: ConfluenceContentStatus | null | undefined;
            readonly id: string;
            readonly links: {
              readonly webUi: string | null | undefined;
            } | null | undefined;
            readonly owner: {
              readonly user: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined;
            readonly space: {
              readonly alias: string | null | undefined;
              readonly id: string;
              readonly key: string | null | undefined;
              readonly name: string | null | undefined;
            } | null | undefined;
            readonly title: string | null | undefined;
            readonly type: ConfluenceContentType | null | undefined;
            readonly viewer: {
              readonly favoritedSummary: {
                readonly isFavorite: boolean;
              } | null | undefined;
            } | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly content?: ReadonlyArray<{
            readonly __typename: "Content";
            readonly blank: boolean;
            readonly excerpt: string;
            readonly id: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly description: string;
          readonly iconUrl: string | null | undefined;
          readonly id: string;
          readonly isVerified?: boolean;
          readonly lastModified?: string | null | undefined;
          readonly space?: {
            readonly id: string;
            readonly name: string | null | undefined;
            readonly webUiLink: string | null | undefined;
          } | null | undefined;
          readonly title: string;
          readonly type: SearchResultType;
          readonly url: string;
          readonly watchDialogContent?: ReadonlyArray<{
            readonly __typename: "Content";
            readonly currentUserIsWatching: boolean;
            readonly id: string | null | undefined;
            readonly space: {
              readonly currentUser: {
                readonly isWatched: boolean;
                readonly isWatchingBlogs: boolean;
              };
              readonly operations: ReadonlyArray<{
                readonly operation: string | null | undefined;
                readonly targetType: string | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      }>;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
      };
      readonly totalCount: number | null | undefined;
      readonly totalCounts: ReadonlyArray<{
        readonly count: number;
        readonly product: string;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly smarts?: {
    readonly recommendedObject: ReadonlyArray<{
      readonly content: ReadonlyArray<{
        readonly __typename: "Content";
        readonly blank: boolean;
        readonly excerpt: string;
        readonly id: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly object: {
        readonly __typename: "ConfluenceBlogPost";
        readonly author: {
          readonly user: {
            readonly __typename: string;
            readonly id: string;
            readonly name: string;
            readonly picture: AGG$URL;
          } | null | undefined;
        } | null | undefined;
        readonly blogPostStatus: ConfluenceBlogPostStatus | null | undefined;
        readonly commentCountSummary: {
          readonly total: number | null | undefined;
        } | null | undefined;
        readonly editorVersion: ReadonlyArray<{
          readonly __typename: "ConfluenceBlogPostProperty";
          readonly key: string;
          readonly value: string;
        } | null | undefined> | null | undefined;
        readonly id: string;
        readonly latestVersion: {
          readonly author: {
            readonly user: {
              readonly __typename: string;
              readonly id: string;
              readonly name: string;
              readonly picture: AGG$URL;
            } | null | undefined;
          } | null | undefined;
          readonly createdAt: AGG$DateTime | null | undefined;
        } | null | undefined;
        readonly likesSummary: {
          readonly count: number | null | undefined;
        } | null | undefined;
        readonly links: {
          readonly __typename: "ConfluenceBlogPostLinks";
          readonly editUi: string | null | undefined;
          readonly webUi: string | null | undefined;
        } | null | undefined;
        readonly metadata: {
          readonly titleEmojiDraft: {
            readonly __typename: "ConfluenceContentTitleEmoji";
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined;
          readonly titleEmojiPublished: {
            readonly __typename: "ConfluenceContentTitleEmoji";
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly owner: {
          readonly user: {
            readonly id: string;
            readonly name: string;
            readonly picture: AGG$URL;
          } | null | undefined;
        } | null | undefined;
        readonly space: {
          readonly __typename: "ConfluenceSpace";
          readonly alias: string | null | undefined;
          readonly id: string;
          readonly key: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly title: string | null | undefined;
        readonly type: ConfluenceContentType | null | undefined;
        readonly viewer: {
          readonly favoritedSummary: {
            readonly isFavorite: boolean;
          } | null | undefined;
        } | null | undefined;
      } | {
        readonly __typename: "ConfluencePage";
        readonly author: {
          readonly user: {
            readonly __typename: string;
            readonly id: string;
            readonly name: string;
            readonly picture: AGG$URL;
          } | null | undefined;
        } | null | undefined;
        readonly commentCountSummary: {
          readonly total: number | null | undefined;
        } | null | undefined;
        readonly editorVersion: ReadonlyArray<{
          readonly __typename: "ConfluencePageProperty";
          readonly key: string;
          readonly value: string;
        } | null | undefined> | null | undefined;
        readonly id: string;
        readonly latestVersion: {
          readonly author: {
            readonly user: {
              readonly __typename: string;
              readonly id: string;
              readonly name: string;
              readonly picture: AGG$URL;
            } | null | undefined;
          } | null | undefined;
          readonly createdAt: AGG$DateTime | null | undefined;
        } | null | undefined;
        readonly likesSummary: {
          readonly count: number | null | undefined;
        } | null | undefined;
        readonly links: {
          readonly __typename: "ConfluencePageLinks";
          readonly editUi: string | null | undefined;
          readonly webUi: string | null | undefined;
        } | null | undefined;
        readonly metadata: {
          readonly titleEmojiDraft: {
            readonly __typename: "ConfluenceContentTitleEmoji";
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined;
          readonly titleEmojiPublished: {
            readonly __typename: "ConfluenceContentTitleEmoji";
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly owner: {
          readonly user: {
            readonly id: string;
            readonly name: string;
            readonly picture: AGG$URL;
          } | null | undefined;
        } | null | undefined;
        readonly pageStatus: ConfluencePageStatus | null | undefined;
        readonly space: {
          readonly __typename: "ConfluenceSpace";
          readonly alias: string | null | undefined;
          readonly id: string;
          readonly key: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly subtype: ConfluencePageSubType | null | undefined;
        readonly title: string | null | undefined;
        readonly type: ConfluenceContentType | null | undefined;
        readonly viewer: {
          readonly favoritedSummary: {
            readonly isFavorite: boolean;
          } | null | undefined;
        } | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SearchResultsAGGSearchQuery = {
  response: SearchResultsAGGSearchQuery$data;
  variables: SearchResultsAGGSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdARI"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commonFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableQueryReplacement"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRecommended"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v14 = {
  "kind": "Variable",
  "name": "experience",
  "variableName": "experience"
},
v15 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "disableQueryReplacement",
    "variableName": "disableQueryReplacement"
  },
  (v14/*: any*/),
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "commonFilters",
        "variableName": "commonFilters"
      },
      {
        "kind": "Variable",
        "name": "confluenceFilters",
        "variableName": "confluenceFilters"
      },
      {
        "kind": "Variable",
        "name": "entities",
        "variableName": "entities"
      },
      {
        "kind": "Variable",
        "name": "locations",
        "variableName": "cloudIdARI"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v19 = {
  "kind": "ScalarField",
  "name": "description"
},
v20 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v21 = {
  "kind": "ScalarField",
  "name": "title"
},
v22 = {
  "kind": "ScalarField",
  "name": "type"
},
v23 = {
  "kind": "ScalarField",
  "name": "url"
},
v24 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v25 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v26 = {
  "kind": "ScalarField",
  "name": "name"
},
v27 = {
  "concreteType": "SearchConfluenceResultSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v26/*: any*/),
    {
      "kind": "ScalarField",
      "name": "webUiLink"
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "currentUserIsWatching"
},
v29 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isWatched"
    },
    {
      "kind": "ScalarField",
      "name": "isWatchingBlogs"
    }
  ]
},
v30 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "blank"
},
v32 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "content",
  "plural": true,
  "selections": [
    (v17/*: any*/),
    (v18/*: any*/),
    (v31/*: any*/),
    {
      "kind": "ScalarField",
      "name": "excerpt"
    }
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v34 = {
  "alias": "pageStatus",
  "kind": "ScalarField",
  "name": "status"
},
v35 = {
  "kind": "ScalarField",
  "name": "webUi"
},
v36 = {
  "kind": "ScalarField",
  "name": "editUi"
},
v37 = [
  (v35/*: any*/),
  (v36/*: any*/)
],
v38 = {
  "concreteType": "ConfluencePageLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v37/*: any*/)
},
v39 = {
  "kind": "ScalarField",
  "name": "key"
},
v40 = {
  "kind": "ScalarField",
  "name": "value"
},
v41 = [
  (v18/*: any*/),
  (v17/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/)
],
v42 = {
  "concreteType": "ConfluenceContentTitleEmoji",
  "kind": "LinkedField",
  "name": "titleEmojiPublished",
  "plural": false,
  "selections": (v41/*: any*/)
},
v43 = {
  "concreteType": "ConfluenceContentTitleEmoji",
  "kind": "LinkedField",
  "name": "titleEmojiDraft",
  "plural": false,
  "selections": (v41/*: any*/)
},
v44 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    (v43/*: any*/)
  ]
},
v45 = [
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "editor"
    ]
  }
],
v46 = [
  (v18/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/)
],
v47 = {
  "alias": "editorVersion",
  "args": (v45/*: any*/),
  "concreteType": "ConfluencePageProperty",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": (v46/*: any*/),
  "storageKey": "properties(keys:[\"editor\"])"
},
v48 = {
  "kind": "ScalarField",
  "name": "alias"
},
v49 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v39/*: any*/),
    (v48/*: any*/),
    (v26/*: any*/)
  ]
},
v50 = {
  "kind": "ScalarField",
  "name": "picture"
},
v51 = [
  {
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v17/*: any*/),
      (v50/*: any*/),
      (v26/*: any*/)
    ]
  }
],
v52 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v51/*: any*/)
},
v53 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v51/*: any*/)
},
v54 = [
  {
    "concreteType": "ConfluenceFavoritedSummary",
    "kind": "LinkedField",
    "name": "favoritedSummary",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isFavorite"
      }
    ]
  }
],
v55 = {
  "concreteType": "ConfluencePageViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v54/*: any*/)
},
v56 = {
  "concreteType": "ConfluenceCommentCountSummary",
  "kind": "LinkedField",
  "name": "commentCountSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "total"
    }
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "count"
},
v58 = {
  "concreteType": "ConfluenceLikesSummary",
  "kind": "LinkedField",
  "name": "likesSummary",
  "plural": false,
  "selections": [
    (v57/*: any*/)
  ]
},
v59 = {
  "alias": "blogPostStatus",
  "kind": "ScalarField",
  "name": "status"
},
v60 = {
  "concreteType": "ConfluenceBlogPostLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v37/*: any*/)
},
v61 = {
  "alias": "editorVersion",
  "args": (v45/*: any*/),
  "concreteType": "ConfluenceBlogPostProperty",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": (v46/*: any*/),
  "storageKey": "properties(keys:[\"editor\"])"
},
v62 = {
  "concreteType": "ConfluenceBlogPostViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v54/*: any*/)
},
v63 = {
  "alias": "contentStatus",
  "kind": "ScalarField",
  "name": "status"
},
v64 = [
  (v35/*: any*/)
],
v65 = {
  "concreteType": "ConfluenceEmbedLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v64/*: any*/)
},
v66 = {
  "concreteType": "ConfluenceContentViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v54/*: any*/)
},
v67 = {
  "concreteType": "ConfluenceDatabaseLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v64/*: any*/)
},
v68 = {
  "concreteType": "ConfluenceWhiteboardLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v64/*: any*/)
},
v69 = {
  "concreteType": "ConfluenceFolderLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v64/*: any*/)
},
v70 = {
  "concreteType": "SearchProductCount",
  "kind": "LinkedField",
  "name": "totalCounts",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "product"
    },
    (v57/*: any*/)
  ]
},
v71 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v72 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "spaceId"
          },
          {
            "kind": "Literal",
            "name": "product",
            "value": "confluence"
          },
          {
            "kind": "Variable",
            "name": "tenantId",
            "variableName": "tenantId"
          },
          {
            "kind": "Literal",
            "name": "userId",
            "value": "context"
          }
        ],
        "kind": "ObjectValue",
        "name": "context"
      },
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "caller",
            "value": "confluence"
          },
          (v14/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "modelRequestParams"
      },
      {
        "kind": "Literal",
        "name": "requestingUserId",
        "value": "context"
      }
    ],
    "kind": "ObjectValue",
    "name": "recommendationsQuery"
  }
],
v73 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "content",
  "plural": true,
  "selections": [
    (v17/*: any*/),
    (v18/*: any*/),
    (v31/*: any*/),
    {
      "args": [
        {
          "kind": "Literal",
          "name": "length",
          "value": 372
        }
      ],
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": "excerpt(length:372)"
    }
  ]
},
v74 = [
  (v35/*: any*/),
  (v36/*: any*/),
  (v18/*: any*/)
],
v75 = {
  "concreteType": "ConfluencePageLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v74/*: any*/)
},
v76 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v43/*: any*/),
    (v42/*: any*/)
  ]
},
v77 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v18/*: any*/),
    (v39/*: any*/),
    (v48/*: any*/),
    (v26/*: any*/)
  ]
},
v78 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v18/*: any*/),
    (v50/*: any*/),
    (v26/*: any*/)
  ]
},
v79 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v78/*: any*/)
  ]
},
v80 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v81 = [
  (v79/*: any*/),
  (v80/*: any*/)
],
v82 = {
  "concreteType": "ConfluenceBlogPostLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v74/*: any*/)
},
v83 = [
  (v18/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v17/*: any*/)
],
v84 = {
  "alias": "editorVersion",
  "args": (v45/*: any*/),
  "concreteType": "ConfluencePageProperty",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": (v83/*: any*/),
  "storageKey": "properties(keys:[\"editor\"])"
},
v85 = [
  {
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v18/*: any*/),
      (v17/*: any*/),
      (v50/*: any*/),
      (v26/*: any*/)
    ]
  },
  (v17/*: any*/)
],
v86 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v85/*: any*/)
},
v87 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v85/*: any*/)
},
v88 = {
  "alias": "editorVersion",
  "args": (v45/*: any*/),
  "concreteType": "ConfluenceBlogPostProperty",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": (v83/*: any*/),
  "storageKey": "properties(keys:[\"editor\"])"
},
v89 = {
  "kind": "InlineFragment",
  "selections": [
    (v17/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v90 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v78/*: any*/),
    (v17/*: any*/)
  ]
},
v91 = [
  (v90/*: any*/),
  (v80/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SearchResultsAGGSearchQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "alias": "results",
            "args": (v15/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/),
                          {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "watchDialogContent",
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v28/*: any*/),
                                  {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v30/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v32/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v38/*: any*/),
                                  (v44/*: any*/),
                                  (v47/*: any*/),
                                  (v49/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  (v58/*: any*/)
                                ],
                                "type": "ConfluencePage"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v44/*: any*/),
                                  (v61/*: any*/),
                                  (v49/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v62/*: any*/),
                                  (v56/*: any*/),
                                  (v58/*: any*/)
                                ],
                                "type": "ConfluenceBlogPost"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v63/*: any*/),
                                  (v65/*: any*/),
                                  (v44/*: any*/),
                                  (v49/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v66/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "type": "ConfluenceEmbed"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v63/*: any*/),
                                  (v67/*: any*/),
                                  (v49/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v66/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "type": "ConfluenceDatabase"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v63/*: any*/),
                                  (v68/*: any*/),
                                  (v49/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v66/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "type": "ConfluenceWhiteboard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v63/*: any*/),
                                  (v69/*: any*/),
                                  (v49/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v66/*: any*/)
                                ],
                                "type": "ConfluenceFolder"
                              }
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      }
                    ]
                  }
                ]
              },
              (v70/*: any*/),
              (v71/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "includeRecommended",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "SmartsQueryApi",
            "kind": "LinkedField",
            "name": "smarts",
            "plural": false,
            "selections": [
              {
                "args": (v72/*: any*/),
                "concreteType": "SmartsRecommendedObject",
                "kind": "LinkedField",
                "name": "recommendedObject",
                "plural": true,
                "selections": [
                  (v73/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "object",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v75/*: any*/),
                          (v76/*: any*/),
                          (v55/*: any*/),
                          (v47/*: any*/),
                          (v77/*: any*/),
                          (v79/*: any*/),
                          (v53/*: any*/),
                          {
                            "concreteType": "ConfluencePageVersion",
                            "kind": "LinkedField",
                            "name": "latestVersion",
                            "plural": false,
                            "selections": (v81/*: any*/)
                          },
                          (v56/*: any*/),
                          (v58/*: any*/)
                        ],
                        "type": "ConfluencePage"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v59/*: any*/),
                          (v82/*: any*/),
                          (v76/*: any*/),
                          (v62/*: any*/),
                          (v61/*: any*/),
                          (v77/*: any*/),
                          (v79/*: any*/),
                          (v53/*: any*/),
                          {
                            "concreteType": "ConfluenceBlogPostVersion",
                            "kind": "LinkedField",
                            "name": "latestVersion",
                            "plural": false,
                            "selections": (v81/*: any*/)
                          },
                          (v56/*: any*/),
                          (v58/*: any*/)
                        ],
                        "type": "ConfluenceBlogPost"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v10/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v11/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Operation",
    "name": "SearchResultsAGGSearchQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "alias": "results",
            "args": (v15/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/),
                          (v32/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v38/*: any*/),
                                  (v44/*: any*/),
                                  (v84/*: any*/),
                                  (v49/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  (v58/*: any*/)
                                ],
                                "type": "ConfluencePage"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v44/*: any*/),
                                  (v88/*: any*/),
                                  (v49/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v62/*: any*/),
                                  (v56/*: any*/),
                                  (v58/*: any*/)
                                ],
                                "type": "ConfluenceBlogPost"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v63/*: any*/),
                                  (v65/*: any*/),
                                  (v44/*: any*/),
                                  (v49/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v66/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "type": "ConfluenceEmbed"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v63/*: any*/),
                                  (v67/*: any*/),
                                  (v49/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v66/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "type": "ConfluenceDatabase"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v63/*: any*/),
                                  (v68/*: any*/),
                                  (v49/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v66/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "type": "ConfluenceWhiteboard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v63/*: any*/),
                                  (v69/*: any*/),
                                  (v49/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v66/*: any*/)
                                ],
                                "type": "ConfluenceFolder"
                              },
                              (v89/*: any*/)
                            ]
                          },
                          {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "watchDialogContent",
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v28/*: any*/),
                                  {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v17/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      }
                    ]
                  }
                ]
              },
              (v70/*: any*/),
              (v71/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "includeRecommended",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "SmartsQueryApi",
            "kind": "LinkedField",
            "name": "smarts",
            "plural": false,
            "selections": [
              {
                "args": (v72/*: any*/),
                "concreteType": "SmartsRecommendedObject",
                "kind": "LinkedField",
                "name": "recommendedObject",
                "plural": true,
                "selections": [
                  (v73/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "object",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v75/*: any*/),
                          (v76/*: any*/),
                          (v55/*: any*/),
                          (v84/*: any*/),
                          (v77/*: any*/),
                          (v90/*: any*/),
                          (v87/*: any*/),
                          {
                            "concreteType": "ConfluencePageVersion",
                            "kind": "LinkedField",
                            "name": "latestVersion",
                            "plural": false,
                            "selections": (v91/*: any*/)
                          },
                          (v56/*: any*/),
                          (v58/*: any*/)
                        ],
                        "type": "ConfluencePage"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v59/*: any*/),
                          (v82/*: any*/),
                          (v76/*: any*/),
                          (v62/*: any*/),
                          (v88/*: any*/),
                          (v77/*: any*/),
                          (v90/*: any*/),
                          (v87/*: any*/),
                          {
                            "concreteType": "ConfluenceBlogPostVersion",
                            "kind": "LinkedField",
                            "name": "latestVersion",
                            "plural": false,
                            "selections": (v91/*: any*/)
                          },
                          (v56/*: any*/),
                          (v58/*: any*/)
                        ],
                        "type": "ConfluenceBlogPost"
                      },
                      (v89/*: any*/)
                    ]
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "767409598881887aa79d216996b506d5",
    "id": "6841cfcc0970a95f1d151af08e5fdeee1588edf1ca9d6b1e88d51154f26c4932",
    "metadata": {},
    "name": "SearchResultsAGGSearchQuery",
    "operationKind": "query",
    "text": "query SearchResultsAGGSearchQuery($query:String!,$cloudIdARI:[String!]!,$limit:Int!,$entities:[String!]!,$commonFilters:SearchCommonFilter,$confluenceFilters:SearchConfluenceFilter,$sort:[SearchSortInput],$after:String,$disableQueryReplacement:Boolean,$experience:String!,$isLicensed:Boolean!,$includeRecommended:Boolean=false,$spaceId:String!,$tenantId:String!){search{results:search(experience:$experience,query:$query,first:$limit,after:$after,sort:$sort,disableQueryReplacement:$disableQueryReplacement,filters:{entities:$entities,locations:$cloudIdARI,commonFilters:$commonFilters,confluenceFilters:$confluenceFilters}){totalCount,edges{node{id,__typename,description,iconUrl,title,type,url,...on SearchConfluencePageBlogAttachment{lastModified,isVerified,space{id,name,webUiLink},watchDialogContent:content@include(if:$isLicensed){id,__typename,currentUserIsWatching,space{currentUser{isWatched,isWatchingBlogs},operations{operation,targetType},id}},content{id,__typename,blank,excerpt},confluenceEntity{__typename,...on ConfluencePage{id,__typename,title,type,subtype,pageStatus:status,links{webUi,editUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},likesSummary{count}},...on ConfluenceBlogPost{id,__typename,title,type,blogPostStatus:status,links{webUi,editUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},likesSummary{count}},...on ConfluenceEmbed{id,__typename,title,type,contentStatus:status,links{webUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceDatabase{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceWhiteboard{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceFolder{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}}},...on Node{__isNode:__typename,id}}}}},totalCounts{product,count},pageInfo{endCursor}}},smarts@include(if:$includeRecommended){recommendedObject(recommendationsQuery:{context:{userId:\"context\",tenantId:$tenantId,product:\"confluence\",containerId:$spaceId},modelRequestParams:{experience:$experience,caller:\"confluence\"},requestingUserId:\"context\"}){content{id,__typename,blank,excerpt(length:372)},object{__typename,...on ConfluencePage{id,__typename,title,type,subtype,pageStatus:status,links{webUi,editUi,__typename},metadata{titleEmojiDraft{__typename,id,key,value},titleEmojiPublished{__typename,id,key,value}},viewer{favoritedSummary{isFavorite}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,__typename,key,alias,name},author{user{id,__typename,picture,name},id},owner{user{__typename,id,picture,name},id},latestVersion{author{user{id,__typename,picture,name},id},createdAt},commentCountSummary{total},likesSummary{count}},...on ConfluenceBlogPost{id,__typename,title,type,blogPostStatus:status,links{webUi,editUi,__typename},metadata{titleEmojiDraft{__typename,id,key,value},titleEmojiPublished{__typename,id,key,value}},viewer{favoritedSummary{isFavorite}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,__typename,key,alias,name},author{user{id,__typename,picture,name},id},owner{user{__typename,id,picture,name},id},latestVersion{author{user{id,__typename,picture,name},id},createdAt},commentCountSummary{total},likesSummary{count}},...on Node{__isNode:__typename,id}},id}}}"
  }
};
})();

(node as any).hash = "d1ed786c62b431549c6e881cb261091e";

export default node;
